<template>
  <v-text-field :label="label" color="green" class="input" type="text" />
</template>

<script>
export default {
  props: ['label'],
};
</script>

<style lang="scss">
.input {
  width: 100%;
  padding: 5px 0px;
}
</style>
